import mifosRepository, { MifosRepository } from "./MifosRepository";

const resource = "/codes";

export default {
  getCodes() {
    mifosRepository.setContentType('application/json');
    return MifosRepository.get(`${resource}`);
  },
  getCodeValues(codeId) {
    mifosRepository.setContentType('application/json');
    return MifosRepository.get(`${resource}/${codeId}/codevalues`);
  }
}